import { TenantTemplateRouterCore } from "@components/tenant/TenantTemplateRouter";
import DefaultInvoicePrint from "./default";

const templates = import.meta.glob<{ default: React.ComponentType<any> }>(
  "/src/pages/user/Invoices/Payments/Print/templates/*/index.tsx"
);

type InvoicePaymentPrintProps = {
};

export default function InvoicePaymentPrint(props: InvoicePaymentPrintProps) {
  return (
    <TenantTemplateRouterCore<InvoicePaymentPrintProps>
      templates={templates}
      DefaultComponent={DefaultInvoicePrint}
      passProps={props}
    />
  );
}